import React from "react";
import {Form, FormGroup} from "reactstrap";
import PropTypes from "prop-types";

import PhysicalPersonProfile from "./PhysicalPersonForm";
import JuridicalPersonProfile from "./JuridicalPersonForm";

function PersonProfileTab({person, changedPerson, showChanges}) {
  const editPerson = {};
  const comparePerson = {};
  Object.keys(person).map(key => {
    if (String(changedPerson[key]) !== String(person[key])) {
      editPerson[key] = changedPerson[key];
      comparePerson[key] = person[key];
    }
    return {};
  });
  editPerson.PersonType = person.PersonType;
  comparePerson.PersonType = person.PersonType;

  return (
    <Form>
      <FormGroup tag="fieldset">
        {person.PersonType === "Physical" ? (
          <PhysicalPersonProfile
            person={comparePerson}
            changedPerson={showChanges ? editPerson : undefined}
          />
        ) : (
          <JuridicalPersonProfile
            person={comparePerson}
            changedPerson={showChanges ? editPerson : undefined}
          />
        )}
      </FormGroup>
    </Form>
  );
}

PersonProfileTab.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired
};

export default PersonProfileTab;
